<template>
  <div class="flex w-full gap-2 mt-1">
    
    <!-- Botón: Tipo de Aceite -->
    <button
      type="button"
      @click="seleccionar('por_aceite')"
      :class="[
        'flex-1 flex items-center justify-center gap-2 h-10 rounded-md text-sm font-semibold',
        selected === 'por_aceite'
          ? 'bg-ROJO_LEON text-white'
          : 'bg-gray-300 text-gray-700'
      ]"
    >
      <svg
        width="16"
        height="22"
        viewBox="0 0 16 22"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        aria-hidden="true"
      >
        <path
          d="M15.3906 8.65723C15.3906 8.49392 15.3282 8.33659 15.2162 8.21774L10.086 2.76689C9.96457 2.63821 9.79571 2.5651 9.61914 2.5651H7.91164V0.641276C7.91164 0.287292 7.62434 0 7.27036 0H3.4227C3.06872 0 2.78143 0.287292 2.78143 0.641276V2.72671C2.76262 2.74338 2.74423 2.76133 2.72713 2.78015L0.162029 5.66589C0.0577148 5.78345 0 5.9348 0 6.09212V17.4C0 17.892 0.18597 18.3418 0.491217 18.6825C0.18597 19.0232 0 19.473 0 19.9651C0 21.0257 0.863158 21.8889 1.92383 21.8889H13.4668C14.5275 21.8889 15.3906 21.0257 15.3906 19.9651C15.3906 19.473 15.2047 19.0232 14.8994 18.6825C15.2047 18.3418 15.3906 17.892 15.3906 17.4V8.65723ZM12.4228 10.4755C12.1748 10.7089 11.8593 10.8243 11.5434 10.8243C11.2022 10.8243 10.8619 10.6892 10.6097 10.4212L7.66453 7.29174C7.17844 6.77572 7.20367 5.96429 7.71883 5.47863C8.23527 4.9934 9.04755 5.01777 9.53193 5.53293L12.4771 8.66236C12.9632 9.17837 12.938 9.9898 12.4228 10.4755Z"
        />
      </svg>

      <span>Tipo de Aceite</span>
    </button>

    <!-- Botón: Por Auto -->
    <button
      type="button"
      @click="seleccionar('por_auto')"
      :class="[
        'flex-1 flex items-center justify-center gap-2 h-10 rounded-md text-sm font-semibold',
        selected === 'por_auto'
          ? 'bg-ROJO_LEON text-white'
          : 'bg-gray-300 text-gray-700'
      ]"
    >
      <svg
        width="23"
        height="17"
        viewBox="0 0 23 17"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.27326 1.53343C6.15622 1.53343 6.086 1.57921 5.99237 1.60209C5.7817 1.69364 5.64125 1.83096 5.54762 2.03695L4.37724 4.48586C4.72835 4.46297 5.07947 4.46297 5.40718 4.44008C7.39683 4.34854 9.40989 4.30276 11.3995 4.30276C11.8209 4.30276 12.2422 4.30276 12.6636 4.30276C12.687 4.2341 12.687 4.14255 12.7338 4.07389C12.8274 3.75347 13.0147 3.45594 13.2956 3.20418C13.7169 2.79222 14.2553 2.56335 14.8639 2.56335C15.4725 2.56335 15.9875 2.76933 16.4322 3.20418C16.6897 3.45594 16.8769 3.75347 16.9706 4.07389C16.994 4.18833 17.0408 4.30276 17.0408 4.4172C17.1578 4.4172 17.2749 4.4172 17.3919 4.44008C17.743 4.46297 18.0941 4.46297 18.4219 4.48586L17.2515 2.03695C17.1578 1.83096 16.994 1.69364 16.7833 1.60209C16.7131 1.57921 16.6195 1.53343 16.5492 1.53343C16.5492 1.53343 16.5492 1.53343 16.5258 1.53343C14.8171 1.30456 13.1083 1.16724 11.3995 1.19013C9.69079 1.16724 7.98202 1.28167 6.27326 1.53343ZM4.65813 1.19013C4.72835 1.0528 4.79858 0.938368 4.89221 0.823933C5.07947 0.640837 5.31355 0.503515 5.59444 0.457741C7.51387 0.160209 9.45671 0 11.3995 0C13.3424 0 15.2618 0.160209 17.1812 0.480628C17.4621 0.549289 17.6962 0.663724 17.8835 0.84682C17.9771 0.938368 18.0707 1.0528 18.1176 1.19013L19.7327 4.37142L20.3881 4.30276L20.2008 3.63904C20.1072 3.34151 20.2477 3.1813 20.5988 3.15841H22.448C22.6586 3.1813 22.7757 3.27285 22.7757 3.47883C22.7991 3.66192 22.7757 3.86791 22.7055 4.09678C22.6118 4.48586 22.3543 4.71473 21.933 4.80628L20.1306 5.12669C20.2945 5.40134 20.4115 5.58444 20.4817 5.6531L21.6053 6.91188C21.6755 6.98054 21.7223 7.04921 21.7926 7.14075C22.1203 7.59849 22.2607 8.14778 22.1671 8.78862C22.1437 9.06326 22.0969 9.33791 22.0735 9.58967C22.0735 9.61255 22.0735 9.63544 22.0735 9.63544C22.0032 10.1618 21.933 10.6425 21.8628 11.1002C21.8628 12.5192 21.8628 13.9153 21.8628 15.3343C21.8628 15.5403 21.7926 15.7005 21.6521 15.8378C21.5117 15.9751 21.3712 16.0438 21.184 16.0438H19.4518C19.2645 16.0438 19.1241 15.9523 19.007 15.8378C18.8666 15.7005 18.7964 15.5403 18.7964 15.3572V13.984C16.3386 14.1442 13.8574 14.2357 11.3761 14.2357C8.89492 14.2357 6.43712 14.1442 3.9559 13.984V15.3572C3.9559 15.5403 3.88568 15.7005 3.74523 15.8378C3.62819 15.9751 3.46434 16.0438 3.30048 16.0438H1.56832C1.38105 16.0438 1.24061 15.9523 1.10016 15.8378C0.959715 15.7005 0.889492 15.5403 0.889492 15.3343C0.889492 13.9153 0.889492 12.5192 0.889492 11.1002C0.819269 10.6425 0.749046 10.1618 0.678823 9.63544C0.678823 9.61255 0.678823 9.58967 0.678823 9.58967C0.655415 9.33791 0.6086 9.06326 0.585192 8.78862C0.514969 8.14778 0.632008 7.62138 0.959715 7.14075C1.00653 7.07209 1.07675 7.00343 1.14698 6.91188L2.27055 5.6531C2.34077 5.56155 2.45781 5.40134 2.62166 5.12669L0.842677 4.80628C0.421338 4.71473 0.163854 4.48586 0.0702231 4.09678C0 3.86791 0 3.66192 0 3.50172C0 3.31862 0.117038 3.20418 0.327708 3.1813H2.17692C2.52803 3.20418 2.66848 3.36439 2.57485 3.66192L2.38758 4.32565L3.043 4.39431L4.65813 1.19013ZM18.141 8.30799C18.141 8.6513 18.258 8.92594 18.4921 9.15481C18.7262 9.38368 19.007 9.49812 19.3582 9.49812C19.7093 9.49812 19.9902 9.38368 20.2242 9.15481C20.4583 8.92594 20.5754 8.62841 20.5754 8.30799C20.5754 7.98757 20.4583 7.69004 20.2242 7.46117C19.9902 7.2323 19.6859 7.11787 19.3582 7.11787C19.0305 7.11787 18.7262 7.2323 18.4921 7.46117C18.258 7.69004 18.141 7.96469 18.141 8.30799ZM16.0343 4.37142C16.0109 4.25699 15.964 4.16544 15.8938 4.07389C15.847 4.00523 15.8002 3.93657 15.73 3.86791C15.4959 3.63904 15.1916 3.5246 14.8639 3.5246C14.5128 3.5246 14.2319 3.63904 13.9978 3.86791C13.9276 3.93657 13.8808 4.00523 13.8339 4.07389C13.7871 4.14255 13.7403 4.2341 13.7169 4.32565C14.466 4.32565 15.2618 4.34854 16.0343 4.37142ZM15.7768 8.44531H7.02231C7.16275 8.62841 7.32661 8.78862 7.49046 8.97172C8.54381 10.0016 9.83123 10.5509 11.3059 10.5509C11.3293 10.5509 11.3527 10.5509 11.3761 10.5509C11.3995 10.5509 11.423 10.5509 11.4464 10.5509C12.9445 10.528 14.2085 10.0016 15.2618 8.97172C15.4725 8.78862 15.6363 8.62841 15.7768 8.44531ZM3.41752 7.09498C3.06641 7.09498 2.78552 7.20941 2.55144 7.43828C2.31736 7.66716 2.20032 7.9418 2.20032 8.2851C2.20032 8.62841 2.31736 8.90306 2.55144 9.13193C2.78552 9.3608 3.08982 9.47523 3.41752 9.47523C3.74523 9.47523 4.04953 9.3608 4.28361 9.13193C4.51768 8.90306 4.63472 8.60552 4.63472 8.2851C4.63472 7.96469 4.51768 7.66716 4.28361 7.43828C4.04953 7.2323 3.76864 7.09498 3.41752 7.09498Z"
        />
      </svg>

      <span>Por Auto</span>
    </button>

  </div>
</template>

<script setup>
const props = defineProps({
  initialValue: {
    type: String,
    default: "por_auto",
  },
});

const emit = defineEmits(["selectedOption"]);

const selected = ref(props.initialValue || "por_auto");

watch(
  () => props.initialValue,
  (nuevo) => {
    if (!nuevo) return;
    // Normalizamos por compatibilidad con valores antiguos
    selected.value = nuevo === "por_patente" ? "por_aceite" : nuevo;
  },
  { immediate: true }
);

const seleccionar = (modo) => {
  selected.value = modo;
  emit("selectedOption", modo);
};
</script>
